import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { PageLayout } from "@/components/layout";
import { HeroSection } from "@/components/home";
import { MobileCTABar, LazySection } from "@/components/shared";
import { SEOHead } from "@/components/shared/SEOHead";

const Index = () => {
  const navigate = useNavigate();
  const ctaSectionRef = useRef<HTMLElement>(null);

  return (
    <PageLayout withMobileCTAPadding>
      <SEOHead
        title={null}
        description="Professional prompt engineering systems for AI fashion photography. CHIMERA™ prompt packs generate editorial-quality imagery with any AI tool. Instant JSON download from $13."
        path="/"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "FSHN Institute",
          "url": "https://fshn.institute",
          "description": "Professional AI fashion prompt engineering",
          "brand": { "@type": "Brand", "name": "CHIMERA™" }
        }}
      />

      {/* Simple background */}
      <div className="fixed inset-0 -z-10 bg-background" />
      
      <HeroSection 
        onBrowseClick={() => navigate("/shop")}
        onLearnMoreClick={() => navigate("/faq")}
      />

      {/* HowItWorks lazy-loaded to defer ~6MB of images from initial bundle */}
      <LazySection
        component={() => import("@/components/home/HowItWorksSection").then(m => ({ default: m.HowItWorksSection }))}
        fallbackHeight="600px"
        rootMargin="400px"
      />

      {/* Below-the-fold sections use intersection observer for true lazy loading */}
      <LazySection
        component={() => import("@/components/home/StorePreviewSection")}
        fallbackHeight="400px"
      />

      <LazySection
        component={() => import("@/components/home/WhatsInsideSection").then(m => ({ default: m.WhatsInsideSection }))}
        fallbackHeight="400px"
      />

      <LazySection
        component={() => import("@/components/home/FeaturesSection").then(m => ({ default: m.FeaturesSection }))}
        fallbackHeight="300px"
      />

      <LazySection
        component={() => import("@/components/home/StatsSection").then(m => ({ default: m.StatsSection }))}
        fallbackHeight="200px"
      />

      <LazySection
        component={() => import("@/components/home/TestimonialsSection").then(m => ({ default: m.TestimonialsSection }))}
        fallbackHeight="300px"
      />

      <LazySection
        component={() => import("@/components/home/CTASection")}
        fallbackHeight="200px"
        componentProps={{ onViewAllPacksClick: () => navigate("/shop") }}
        sectionRef={ctaSectionRef}
      />

      <MobileCTABar
        variant="browse" 
        onAction={() => navigate("/shop")}
        ctaSectionRef={ctaSectionRef}
      />
    </PageLayout>
  );
};

export default Index;
